import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "number flex" }
const _hoisted_3 = { class: "num-time mg-r-20" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "detail-value" }
const _hoisted_6 = { class: "detail-value" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "detail-value" }
const _hoisted_9 = { class: "detail-value" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_searchComponent = _resolveComponent("searchComponent")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_export_button = _resolveComponent("export-button")!
  const _component_orderList = _resolveComponent("orderList")!
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_peopleList = _resolveComponent("peopleList")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, {
      shadow: "never",
      class: "mg-t-20"
    }, {
      default: _withCtx(() => [
        (_ctx.type === 'all')
          ? (_openBlock(), _createBlock(_component_searchComponent, {
              key: 0,
              "search-list": _ctx.searchListAll,
              "onUpdate:searchList": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchListAll) = $event)),
              "button-list": _ctx.buttonList,
              onDoSearch: _ctx.handleSearch
            }, null, 8, ["search-list", "button-list", "onDoSearch"]))
          : _createCommentVNode("", true),
        (_ctx.type === 'not')
          ? (_openBlock(), _createBlock(_component_searchComponent, {
              key: 1,
              "search-list": _ctx.searchListNot,
              "onUpdate:searchList": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchListNot) = $event)),
              "button-list": _ctx.buttonList,
              onDoSearch: _ctx.handleSearch
            }, null, 8, ["search-list", "button-list", "onDoSearch"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, {
      shadow: "never",
      class: "mg-t-20 parent"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (_ctx.type === 'all')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  _cache[3] || (_cache[3] = _createElementVNode("span", { class: "detail-key" }, "累计：", -1)),
                  _createElementVNode("span", _hoisted_5, "¥" + _toDisplayString(_ctx.countData.amount), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("span", { class: "detail-key mg-l-10" }, "共：", -1)),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.countData.count), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "detail-key" }, "笔", -1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.type === 'not')
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "detail-key" }, "累计：", -1)),
                  _createElementVNode("span", _hoisted_8, "¥" + _toDisplayString(_ctx.countData.amount), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "detail-key mg-l-10" }, "共：", -1)),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.countData.count), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "detail-key" }, "人", -1))
                ]))
              : _createCommentVNode("", true)
          ]),
          (_ctx.type === 'all')
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_el_button, {
                  class: "son",
                  type: "primary",
                  size: "small",
                  onClick: _ctx.handlerCreateZdRecipt
                }, {
                  default: _withCtx(() => _cache[9] || (_cache[9] = [
                    _createTextVNode("生成子弹回单")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_export_button, {
                  "no-icon": "",
                  class: "son",
                  type: "primary",
                  size: "small",
                  onExport: _ctx.handlerDownLoadZdRecipt
                }, {
                  default: _withCtx(() => _cache[10] || (_cache[10] = [
                    _createTextVNode("下载子弹回单")
                  ])),
                  _: 1
                }, 8, ["onExport"]),
                _createVNode(_component_el_button, {
                  class: "son",
                  size: "small",
                  onClick: _ctx.onExportOrder
                }, {
                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                    _createTextVNode("导出勾选")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.type === 'not')
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createVNode(_component_el_button, {
                  class: "son",
                  type: "primary",
                  size: "small",
                  onClick: _ctx.handlerCreateWxRecipt
                }, {
                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                    _createTextVNode("生成微信回单")
                  ])),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_export_button, {
                  "no-icon": "",
                  class: "son",
                  type: "primary",
                  size: "small",
                  onExport: _ctx.handlerDownLoadWxRecipt
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createTextVNode("下载微信回单")
                  ])),
                  _: 1
                }, 8, ["onExport"]),
                _createVNode(_component_export_button, {
                  "no-icon": "",
                  class: "son",
                  type: "primary",
                  size: "small",
                  onExport: _ctx.handlerDownLoadZdReciptDetail
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createTextVNode("下载子弹回单")
                  ])),
                  _: 1
                }, 8, ["onExport"]),
                _createVNode(_component_el_button, {
                  class: "son",
                  size: "small",
                  onClick: _ctx.onExport
                }, {
                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                    _createTextVNode("导出勾选")
                  ])),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_el_tabs, {
          modelValue: _ctx.type,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.type) = $event)),
          onTabClick: _ctx.handleClick
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "预支单",
              name: "all"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_orderList, {
                  ref: "order",
                  "search-data": _ctx.createQuery(_ctx.searchListAll),
                  onSelects: _ctx.handleSelects,
                  onCountData: _ctx.handleCountData
                }, null, 8, ["search-data", "onSelects", "onCountData"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "预支人员明细",
              name: "not"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_peopleList, {
                  ref: "people",
                  "search-data": _ctx.createQuery(_ctx.searchListNot),
                  onSelects: _ctx.handleSelectsNot,
                  onCountData: _ctx.handleCountData
                }, null, 8, ["search-data", "onSelects", "onCountData"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onTabClick"])
      ]),
      _: 1
    })
  ]))
}